import { render, staticRenderFns } from "./staffeView.vue?vue&type=template&id=2ff05c04&scoped=true&"
import script from "./staffeView.vue?vue&type=script&lang=js&"
export * from "./staffeView.vue?vue&type=script&lang=js&"
import style0 from "./staffeView.vue?vue&type=style&index=0&id=2ff05c04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff05c04",
  null
  
)

export default component.exports